export default {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            label: {
                backgroundColor: '#6a7985'
            }
        }
    },
    legend: {
        data: ['产量'],
        show: false
    },
    toolbox: {
        feature: {
            // saveAsImage: {}
        }
    },
    grid: {
        left: '30',
        right: '20',
        top: '20',
        bottom: '',
        containLabel: true
    },
    xAxis: [
        {
            splitLine: {
                show: true,
                lineStyle: {
                    color: ['#444c59'],
                    width: 1,
                    type: 'solid'
                }
            },

            type: 'category',

            axisLabel: {
                textStyle: {
                    color: '#fff',
                    fontSize: 22
                }
            },
            axisLine: {
                lineStyle: {
                    show: false,
                    color: '#444c59'
                }
            }

        }
    ],
    yAxis: [
        {
            splitLine: {
                show: true,
                lineStyle: {
                    color: ['#444c59'],
                    width: 1,
                    type: 'solid'
                }
            },
            axisLabel: { fontSize: 22 },
            offset: 0,
            axisLine: {
                show: false,
                lineStyle: {
                    color: '#fff',
                    width: 0
                }

            },
            axisTick: {
                show: false
            },

            type: 'value',

        }
    ],
    series: [
        {



            smooth: true,
            name: '',
            type: 'bar',
            barWidth: '60%',
            itemStyle: {
                normal: {
                    color: '#3680f8', //改变折线点的颜色
                    lineStyle: {
                        color: '#3398DB' //改变折线颜色
                    }
                }
            },
        }
    ]
}